import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2104AffilaitionRoleHandler } from "./U2104AffilaitionRoleHandlers";
import type { U2104AffiliationRole } from "../../../../U2104Service";

// Typage des props du composant
interface U2104AffilaitionRoleDeleteDlgProps {
  u2104AffilaitionRoleHandler: U2104AffilaitionRoleHandler;
  t: TFunction;
  NS: string;
}

function U2104AffilaitionRoleDeleteDlg({ u2104AffilaitionRoleHandler, t, NS }: U2104AffilaitionRoleDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2104AffilaitionRoleHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2104AffilaitionRoleHandler.isDeleteDialogOpen} onClose={u2104AffilaitionRoleHandler.onDlgDeleteClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUserRole", {
          count: u2104AffilaitionRoleHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2104AffilaitionRoleHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const role = row as unknown as U2104AffiliationRole;
          return (
            <span key={role.roleCode} className="inline-block text-gray-800">
              {`${role.roleCode} - ${role.roleDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2104AffilaitionRoleDeleteDlg;
